import React, {Component} from 'react';
import axios from 'axios';
import InsuranceItem from './misc/InsuranceItem';
import {phoneNumberMask, states, dateMask } from '../utilities';
import moment from 'moment';

import Loader from '../elements/Loader'

class Register extends Component {
  constructor(props){
    super(props);
    this.state = {
      lastName: '',
      firstName: '',
      dob: '',
      gender: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      email: '',
      confirmEmail: '',
      phone: '',
      passport: '',
      insuranceID: '',
      policy: '',
      isInsurance: '',
      submitted: false,
      insurance: '',
      insuranceID: '',
      policy: '',
      otherInsuranceInfo: {
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: ''
      },
      relationToInsured: '',
      guarantor: {
        lastName: '',
        firstName: '',
        dob: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
      },
      errors: [],
      fileBase64: '',
      isFileUploading: false,
      fileType: '',
      test: '',
      isAnswered: true,
      question1: '',
      question2: '',
      question3: '',
      question4: '',
      question5: '',
      question6: '',
      question7: '',
      question8: '',
      isValidAnswer: true,
      loading: false,
      error: '',
      consent: false,
      agree: false,
    }
  }

  onChangeOtherInsurance = (key, value, e) => {
    if(key === 'phone'){
      value = phoneNumberMask(value)
    } else {
      value = value.toUpperCase();
    }
    let newInsurance = {...this.state.otherInsuranceInfo};
    newInsurance[key] = value;
    this.setState({otherInsuranceInfo: newInsurance, insurance: value})
  }

  onChangeGuarantor = (key, value, e) => {
    if(key === 'dob'){
      value = dateMask(value)
    } else if(key === 'phone'){
      value = phoneNumberMask(value)
    } else {
      value = value.toUpperCase();
    }
    let newGuarantor = {...this.state.guarantor};
    newGuarantor[key] = value;
    this.setState({guarantor: newGuarantor})
  }

  handleChange = (key, value, e) => {
    this.setState({[key]: value})
  }

  onChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if(name === 'phone'){
      value = phoneNumberMask(value)
    }
    if(name === 'dob'){
      value = dateMask(value)
    }
    this.setState({
      [name]: value
    })
  }

  onSelectInsurance = (id, name) => {
    this.setState({insuranceID: id, insurance: name})
  }

  register = () => {
    this.setState({
      loading: true
    })
    let formData = {};
    formData.guarantor = this.state.guarantor;
    formData.clientID = this.props.match.params.id;
    formData.otherInsuranceInfo = this.state.otherInsuranceInfo;

    formData.question1 = this.state.question1;
    formData.question2 = this.state.question2; 
    formData.question3 = this.state.question3; 
    formData.question4 = this.state.question4; 
    formData.question5 = this.state.question5; 
    formData.question6 = this.state.question6; 
    formData.question7 = this.state.question7; 
    formData.question8 = this.state.question8; 

    let errors = [];
    if (this.state.lastName){
      formData.lastName = this.state.lastName;
    } else {
      errors.push("Last Name is required")
    }

    if (this.state.passport){
      formData.passport = this.state.passport;
    }

    if (this.state.firstName){
      formData.firstName = this.state.firstName;
    } else {
      errors.push("First Name is required")
    }

    if (this.state.dob && moment(this.state.dob, 'MM/DD/YYYY').isValid()){
      formData.dob = this.state.dob;
    } else {
      errors.push("Please enter a valid DOB")
    }

    if (this.state.gender){
      formData.gender = this.state.gender;
    } else {
      errors.push("Gender is required")
    }

    if (this.state.address){
      formData.address = this.state.address;
    } else {
      errors.push("Address is required")
    }

    if (this.state.city){
      formData.city = this.state.city;
    } else {
      errors.push("City is required")
    }

    if (this.state.state){
      formData.state = this.state.state;
    } else {
      errors.push("State is required")
    }

    if (this.state.zip){
      formData.zip = this.state.zip;
    } else {
      errors.push("Zip is required")
    }

    if (this.state.email){
      if (this.state.confirmEmail) {
        if (this.state.confirmEmail === this.state.email){
          formData.email = this.state.email;
        } else {
          errors.push("Email and Confirm Email do not match")
        }
      } else {
        errors.push("Please confirm email")
      }       
    } else {
      if (this.state.phone){
        formData.email = "";
      } else {
        errors.push("Email or Phone is required")
      }      
    }

    if (this.state.phone){
      formData.phone = this.state.phone;
    } else {
      if (this.state.email){
        formData.phone = "";
      }  
    }     

    if (this.state.isInsurance){
      if (this.state.isInsurance === '1'){
        if (this.state.policy){
          formData.policy = this.state.policy;
        } else {
          errors.push("Policy is required")
        }
        if (this.state.insurance){
          formData.insurance = this.state.insurance;
        } else {
          errors.push("Insurance Name is required")
        }
        if (this.state.relationToInsured){
          formData.relationToInsured = this.state.relationToInsured;
          if (this.state.relationToInsured === 'Self'){
            formData.guarantor = {
              lastName: this.state.lastName,
              firstName: this.state.firstName,
              dob: this.state.dob,
              address: this.state.address,
              city: this.state.city,
              state: this.state.state,
              zip: this.state.zip,
              phone: this.state.phone,
            }
          } else {
            if (this.state.guarantor.lastName){
              formData.guarantor.lastName = this.state.guarantor.lastName;
            } else {
              errors.push("Guarantor Last Name is required")
            }
        
            if (this.state.guarantor.firstName){
              formData.guarantor.firstName = this.state.guarantor.firstName;
            } else {
              errors.push("Guarantor First Name is required")
            }
        
            if (this.state.guarantor.dob){
              formData.guarantor.dob = this.state.guarantor.dob;
            } else {
              errors.push("Guarantor Date of Birth is required")
            }
        
            if (this.state.guarantor.address){
              formData.guarantor.address = this.state.guarantor.address;
            } else {
              errors.push("Guarantor Address is required")
            }
        
            if (this.state.guarantor.city){
              formData.guarantor.city = this.state.guarantor.city;
            } else {
              errors.push("Guarantor City is required")
            }
        
            if (this.state.guarantor.state){
              formData.guarantor.state = this.state.guarantor.state;
            } else {
              errors.push("Guarantor State is required")
            }
        
            if (this.state.guarantor.zip){
              formData.guarantor.zip = this.state.guarantor.zip;
            } else {
              errors.push("Guarantor Zip is required")
            }
        
            if (this.state.guarantor.phone){
              formData.guarantor.phone = this.state.guarantor.phone;
            } else {
              errors.push("Guarantor Phone is required")
            }
          }
        } else {
          errors.push("Relation to insured is required")
        }
        formData.insuranceID = this.state.insuranceID;
        formData.otherInsuranceInfo = this.state.otherInsuranceInfo;
      }      
    } else {
      errors.push("Are You Insured?")
    }

    if (this.state.fileBase64){
      // formData.fileBase64 = ''
      formData.fileBase64 = this.state.fileBase64;
      formData.fileType = this.state.fileType;
    } else {
      errors.push("Picture of your ID is required")
    }

    // if (this.state.test){
    //   formData.test = this.state.test;
    // } else {
    //   errors.push("Select a test")
    // }

    if (!this.state.consent){
      errors.push("Please acknowledge that you read Consent Form")
    }

    if (errors.length){
      this.setState({
        errors: errors,
        loading: false,
      })
    } else {
      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_URL}/registration`,
        data: formData,
      }).then(res => {
        console.log(res)
        if (res.data.err){
          this.setState({
            error: res.data.err,
            lastName: '',
            firstName: '',
            dob: '',
            gender: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            insuranceID: '',
            policy: '',
            isInsurance: '',
            insurance: '',
            insuranceID: '',
            policy: '',
            otherInsuranceInfo: {
              name: '',
              address: '',
              city: '',
              state: '',
              zip: '',
              phone: ''
            },
            relationToInsured: '',
            guarantor: {
              lastName: '',
              firstName: '',
              dob: '',
              address: '',
              city: '',
              state: '',
              zip: '',
              phone: '',
            },
            fileBase64: '',
            fileType: '',
            test: '',
            errors: [],
            isAnswered: true,
            question1: '',
            question2: '',
            question3: '',
            question4: '',
            question5: '',
            question6: '',
            question7: '',
            question8: '',
            loading: false,
            consent: false,
          })
        } else {
          this.setState({
            submitted: true,
            lastName: '',
            firstName: '',
            dob: '',
            gender: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            insuranceID: '',
            policy: '',
            isInsurance: '',
            insurance: '',
            insuranceID: '',
            policy: '',
            otherInsuranceInfo: {
              name: '',
              address: '',
              city: '',
              state: '',
              zip: '',
              phone: ''
            },
            relationToInsured: '',
            guarantor: {
              lastName: '',
              firstName: '',
              dob: '',
              address: '',
              city: '',
              state: '',
              zip: '',
              phone: '',
            },
            fileBase64: '',
            fileType: '',
            test: '',
            errors: [],
            isAnswered: false,
            question1: '',
            question2: '',
            question3: '',
            question4: '',
            question5: '',
            question6: '',
            question7: '',
            question8: '',
            loading: false,
            consent: false,
          })
        }        
      }).catch(err => {
        console.log(err)
      })
    }
  }

  back = () => {
    this.setState({
      submitted: false,
      error: '',
    })
  }

  onFileUpload = (event) => {
    const reader = new FileReader();
    const file = event.target.files[0];
    const newState = {...this.state};


    reader.onloadend = () => {
      newState.fileBase64 = reader.result;
    };
    
    reader.readAsDataURL(file);

    this.setState({
      isFileUploading: true,
      isValid: false,
    }, () => {
      const checkReadyState = setInterval(() => {
        console.log(reader)
        let file = newState.fileBase64.split(';base64')[0];
        newState.fileType = file.split('/')[1]
        console.log(newState.fileType)
        if (reader.readyState === 2) {
          clearInterval(checkReadyState);
          this.setState(newState);
        }
      }, 1000);
    });
  }

  answer = () => {
    let isValid = true;
    let validAnswer = false;
    if (!this.state.question1){
      isValid = false;
    } else {
      if (this.state.question1 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question2){
      isValid = false;
    } else {
      if (this.state.question2 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question3){
      isValid = false;
    } else {
      if (this.state.question3 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question4){
      isValid = false;
    } else {
      if (this.state.question4 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question5){
      isValid = false;
    } else {
      if (this.state.question5 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question6){
      isValid = false;
    } else {
      if (this.state.question6 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question7){
      isValid = false;
    } else {
      if (this.state.question7 === '1'){
        validAnswer = true;
      }
    }
    if (!this.state.question8){
      isValid = false;
    } else {
      if (this.state.question8 === '1'){
        validAnswer = true;
      }
    }
    console.log(validAnswer)
    if (isValid && validAnswer){
      this.setState({
        isAnswered: true,
        errors: [],

      })
    } else if (isValid && !validAnswer){
      this.setState({
        isValidAnswer: false,
      })
    } else {
      let errors = ['Please answer all the questions']
      this.setState({
        errors: errors
      })
    }
  }

  changeAnswer = () => {
    this.setState({
      isValidAnswer: true
    })
  }

  handleConsent = (e) => {
    this.setState({
      consent: !this.state.consent
    })
  }

  consent = () => {
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/consent`)
  }

  agree = () => {
    this.setState({
      agree: true
    })
  }

  renderForm(){
    return(
      <div>
        <h3>Welcome to Empire City Laboratories</h3>
        <form className="form m-t" role="form">
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your First Name' 
              required='required'
              name="firstName" 
              value={this.state.firstName} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your Last Name' 
              required='required'
              name="lastName" 
              value={this.state.lastName} 
              onChange={this.onChange}/>
          </div>              
          <div className="form-group">
            <label>Date of Birth</label>
            <input className="form-control input-sm" 
              type='text' 
              placeholder='MM/DD/YYYY' 
              required='required'
              name="dob" 
              value={this.state.dob} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <select className="form-control input-sm" name="gender" value={this.state.gender} onChange={this.onChange}>
              <option value="">Select Gender</option>
              <option value="F">Female</option>
              <option value="M">Male</option>
              <option value="U">Prefer not to answer</option>
            </select>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your Address' 
              required='required'
              name="address" 
              value={this.state.address} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your City' 
              required='required'
              name="city" 
              value={this.state.city} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <select className="form-control input-sm" name="state" value={this.state.state} onChange={this.onChange}>
              <option value="">Select State</option>
              {states.map(item => 
                <option key={item.abbreviation} value={item.abbreviation}>{item.name}</option>
              )}
            </select>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
            type='text' 
            placeholder='Enter Your Zip' 
            required='required'
            name="zip" 
            value={this.state.zip} 
            onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your Email' 
              required='required' 
              name="email" 
              value={this.state.email} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Confirm Your Email' 
              required='required' 
              name="confirmEmail" 
              value={this.state.confirmEmail} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
            type='text' 
            placeholder='Enter Your Phone' 
            required='required' 
            name="phone" 
            value={this.state.phone} 
            onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Your Passport # (OPTIONAL)' 
              required='required' 
              name="passport" 
              value={this.state.passport} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <select className="form-control input-sm" name="isInsurance" value={this.state.isInsurance} onChange={this.onChange}>
              <option value="">Do you have an insurance?</option>
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
          {this.state.isInsurance && this.state.isInsurance !== '0' ? 
            <InsuranceItem 
              name={this.state.insurance} 
              id={this.state.insuranceID} 
              policy={this.state.policy} 
              relationToInsured={this.state.relationToInsured}
              guarantor={this.state.guarantor}
              onChangeGuarantor={this.onChangeGuarantor}
              onSelectInsurance={this.onSelectInsurance} 
              otherInsuranceInfo={this.state.otherInsuranceInfo}
              onChangeOtherInsurance={this.onChangeOtherInsurance}
              onChange={this.handleChange}
            /> : null
          } 
          <div className="form-group">
            <label className="iblock">
              <span tabIndex="0" className={`btn btn-sm btn-block ${this.state.fileBase64 && !this.state.isFileUploading ? 'btn-success' : 'btn-default'}`}>
                {
                  this.state.isFileUploading ?
                    <span><i className="fa fa-spinner fa-pulse fa-fw" /> Uploading...</span>
                  :
                  this.state.fileBase64 ?
                    <span><i className="fa fa-check" /> File uploaded</span>
                  :
                  <span><i className="fa fa-search" /> Upload Your ID</span>
                }
              </span>
              <input type="file" className="hidden" onChange={this.onFileUpload} value="" />
            </label>
          </div>  
          {/* <div className="form-group">
            <select className="form-control input-sm" name="test" value={this.state.test} onChange={this.onChange}>
              <option value="">Select Test</option>
              <option value="pcr">Covid-19 PCR Only</option>
              {this.props.match.params.id !== "22901" && this.props.match.params.id !== "22927" &&
              this.props.match.params.id !== "22301" && this.props.match.params.id !== "22913" &&
              this.props.match.params.id !== "22909" && this.props.match.params.id !== "22912" &&
              this.props.match.params.id !== "22933" && this.props.match.params.id !== "22932" &&
              this.props.match.params.id !== "21635" && this.props.match.params.id !== "22945" && 
              this.props.match.params.id !== "22948" && this.props.match.params.id !== "22959" &&
              this.props.match.params.id !== "22968" && this.props.match.params.id !== "22890" &&
              this.props.match.params.id !== "22824" && this.props.match.params.id !== "22963" &&
              this.props.match.params.id !== "22964" && this.props.match.params.id !== "22965" &&
              this.props.match.params.id !== "22966" && this.props.match.params.id !== "22967" &&
              this.props.match.params.id !== "22969" && this.props.match.params.id !== "22970" &&
              this.props.match.params.id !== "22971" && this.props.match.params.id !== "22972" &&
              this.props.match.params.id !== "22973" && this.props.match.params.id !== "22974" &&
              this.props.match.params.id !== "22975" && this.props.match.params.id !== "22976" &&
              this.props.match.params.id !== "22977" && this.props.match.params.id !== "22978" &&
              this.props.match.params.id !== "22979" && this.props.match.params.id !== "22980" && 
              this.props.match.params.id !== "23002" && this.props.match.params.id !== "22994" && 
              this.props.match.params.id !== "23013" && this.props.match.params.id !== "23004" &&              
              this.props.match.params.id !== "23050" && this.props.match.params.id !== "23051" && 
              this.props.match.params.id !== "23052" && this.props.match.params.id !== "23053" &&
              this.props.match.params.id !== "23022" && this.props.match.params.id !== "23023" &&
              this.props.match.params.id !== "23105" && this.props.match.params.id !== "23103" &&              
              this.props.match.params.id !== "23104" && this.props.match.params.id !== "23108" && 
              this.props.match.params.id !== "23109" && this.props.match.params.id !== "23110" &&
              this.props.match.params.id !== "23111" && this.props.match.params.id !== "23112" && 
              this.props.match.params.id !== "23024" && this.props.match.params.id !== "23170" &&
              this.props.match.params.id !== "23212" && this.props.match.params.id !== "23230" &&
              this.props.match.params.id !== "23012" 
              ? <option value="rapid">Covid-19 Rapid & PCR</option>: null}
              <option value="pcr">Covid-19 Neutralizing Antobody</option>
            </select>
          </div>          */}
        </form>
        {this.state.errors ? 
          <ul style={{color: 'red', fontWeight: 'bold', listStyle: 'none', textAlign: 'left'}}>
            {this.state.errors.map((item, index) => <li key={index}>{item}</li>)}
          </ul> : null
        }
        <a onClick={this.consent}><h3 style={{textDecoration: "underline"}}>Patient Consent Form</h3></a>
        <input type="checkbox" name="consent" value={this.state.consent} checked={this.state.consent} onChange={this.handleConsent}/> I acknowledge that I have read Patient Concent Form above.
        <button className="btn block btn-primary full-width m-b" onClick={this.register}>{this.state.loading ? <Loader/> : 'I have read patient consent form. Register'}</button>
        <p className="m-t"><small>&copy; 2008-2021 Empire City Laboratories, Inc. All Rights Reserved. ECL and Empire City Laboratories are registered trademarks of Empire City Laboratories®, Inc.</small></p>
      </div> 
    )
  }

  renderQuestions(){
    if (this.state.isValidAnswer){
      return(
        <div>
          <h3>Welcome to Empire City Laboratories</h3>
          <form className="form m-t" role="form">
            <div className="form-group">
              <label>1) Are you seeking a test to prevent possible spread of COVID-19 for future travel or recreation (according to CDC guidelines)?</label>
              <select className="form-control input-sm" name="question1" value={this.state.question1} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>2) Are you seeking a test to prevent possible spread of COVID-19 after being at a place where social distancing was not possible?</label>
              <select className="form-control input-sm" name="question2" value={this.state.question2} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>3) Have you had close contact with someone with a confirmed case of COVID-19?</label>
              <select className="form-control input-sm" name="question3" value={this.state.question3} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>4) Are you a resident in a special setting where the risk of COVID-19 transmission may be high?</label>
              <select className="form-control input-sm" name="question4" value={this.state.question4} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>5) Do you work in health care?</label>
              <select className="form-control input-sm" name="question5" value={this.state.question5} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>6) Do you work in a special setting where the risk of COVID-19 transmission may be high?</label>
              <select className="form-control input-sm" name="question6" value={this.state.question6} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>7) Have you been asked or referred to get tested by a health care provider?</label>
              <select className="form-control input-sm" name="question7" value={this.state.question7} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
            <div className="form-group">
              <label>8) Have you experienced any symptoms in the last 14 days?</label>
              <select className="form-control input-sm" name="question8" value={this.state.question8} onChange={this.onChange}>
                <option value="">Select</option>
                <option value="1">YES</option>
                <option value="0">NO</option>
              </select>
            </div>
          </form>
          {this.state.errors ? 
            <ul style={{color: 'red', fontWeight: 'bold', listStyle: 'none', textAlign: 'left'}}>
              {this.state.errors.map((item, index) => <li key={index}>{item}</li>)}
            </ul> : null
          }
          <button className="btn block btn-primary full-width" onClick={this.answer}><i className="fa fa-check"></i> I acknowledge that I have answered <br/>these questions truthfully to the best <br/>of my knowledge.</button>
          <p className="m-t"><small>&copy; 2008-2021 Empire City Laboratories, Inc. All Rights Reserved. ECL and Empire City Laboratories are registered trademarks of Empire City Laboratories®, Inc.</small></p>
        </div>
      )
    } else {
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h3 className="font-bold" style={{fontSize: '18pt', lineHeight: '30px'}}>
              Based on the information you provided, testing is not recommended for you at this time.
            </h3>
            <br/>
            <br/><br/>
            <button className="btn btn-primary" onClick={this.changeAnswer}>Back</button>
          </div>
        </div>
      )
    }    
  }

  render(){
    if (!this.state.agree) {
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h3>
              <span style={{color: 'red'}}>Please be advised:</span> We are no longer able to submit COVID-19 claims for uninsured patients. We have been notified by the Health Resources and Services Administration’s (HRSA) COVID-19 Uninsured Program that they will stop accepting claims as of March 22nd, 2022.  We will no longer be able to submit claims for COVID-19 test(s) for uninsured patients.  However, testing is still available for uninsured patients that wish to pay for the test. 
            </h3>
            <button className="btn btn-primary" onClick={this.agree}>Agree</button>
          </div>
        </div>
      )
    } else if (this.state.submitted){
      return (
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h1 className="font-bold" style={{fontSize: '18pt', lineHeight: '30px'}}>Thank you for registering!</h1>
            <br/>
            <i className="fa fa-thumbs-up modal-icon modal-icon-warning" style={{fontSize: '100pt'}}></i>
            <br/><br/>
            <button className="btn btn-primary" onClick={this.back}>Back</button>
          </div>
        </div>
      )
    } else if(this.state.error){
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h1 className="font-bold" style={{fontSize: '18pt', lineHeight: '30px'}}>{this.state.error}</h1>
            <br/>
            <i className="fa fa-warning modal-icon modal-icon-danger" style={{fontSize: '100pt'}}></i>
            <br/><br/>
            <button className="btn btn-primary" onClick={this.back}>Back</button>
          </div>
        </div>
      )      
    } else {
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          {this.renderForm()}
        </div>
      )
    }    
  }
}
export default Register